var map = {
	"./about-app/game.svg": 598,
	"./about-app/learn.svg": 599,
	"./about-app/scan.svg": 600,
	"./about-app/tips.svg": 601,
	"./arrow.svg": 563,
	"./bt-round-active.svg": 572,
	"./bt-round-hover.svg": 573,
	"./bt-round.svg": 574,
	"./check-box-checked.svg": 560,
	"./close.svg": 654,
	"./contract.svg": 655,
	"./done.svg": 575,
	"./download.svg": 656,
	"./email.svg": 657,
	"./feedback.svg": 307,
	"./game.svg": 658,
	"./go.svg": 659,
	"./menu.svg": 660,
	"./next.svg": 661,
	"./polygon_arrow.svg": 566,
	"./search.svg": 662,
	"./sign.svg": 308,
	"./vertical_dots.svg": 559,
	"./words-containing-outlined.svg": 663
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 653;